import { Form } from "@redriver/cinnamon-mui";
import { requestedCorrectionsLookup } from "modules/lookups";

const RequestedCorrectionDropdown = ({ ...props }) => (
  <Form.Dropdown {...props} lookup={requestedCorrectionsLookup} />
);

export default RequestedCorrectionDropdown;
